import React, { useCallback, useState } from "react";
import { useCollection } from "react-firebase-hooks/firestore";
import { designationQuery } from "../utils/queryHelpers";
import { Loader } from "../hooks/useLoading";
import EditDesignation from "../components/EditDesignation";
import DeleteModal from "../components/DeleteBusiness";
import { DESIGNATIONS } from "../utils/constants";

const Designations = () => {
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selected, setSelected] = useState(null);

  const [snapshot, loading, error] = useCollection(designationQuery(), {
    snapshotListenOptions: {
      includeMetadataChanges: true,
    },
  });

  const [dialogType, setDialogType] = useState("Add");
  const designationList = [{ title: "MD" }, { title: "CMD" }];

  const onDeleteModalClose = useCallback(() => {
    setShowDeleteModal(false);
    setSelected(null);
  }, []);

  return (
    <>
      <header className="d-flex  justify-content-between mb-3">
        <h3>Designations</h3>
        <div className="d-flex gap-2">
          {/* <select
        className="form-control"
        value={status}
        onChange={(e) => {
          setstatus(e.target.value);
        }}
      >
        <option value="Created">Created</option>
        <option value="Sent Email">Sent Email</option>
        <option value="Code Expired">Code Expired</option>
        <option value="Joined">Joined</option>
      </select> */}
          <button
            className="btn btn-dark"
            onClick={() => {
              setShowEditModal(true);
              setDialogType("Add");
              //   setTime(Timestamp.now());
            }}
          >
            Add
          </button>
        </div>
      </header>
      <main className="position-relative" style={{ width: "50%" }}>
        {loading && <Loader />}
        {error ? (
          <p className="text-error">
            There is some error. Please try again later
          </p>
        ) : null}
        <table className="table">
          <thead className="table-secondary">
            <tr>
              <th>Sr No.</th>
              <th>Title</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {snapshot?.docs?.length < 1 ? (
              <tr>
                <td colSpan={4} className="text-center">
                  No Data Available
                </td>
              </tr>
            ) : (
              snapshot?.docs?.map((data, index) => {
                const d = { ...data.data(), id: data.id };
                return (
                  <tr key={d.id} className="align-items-center">
                    <td>{index + 1}</td>
                    <td>{d.title}</td>
                    <td className="d-flex gap-1">
                      {" "}
                      <button
                        className="btn btn-secondary btn-sm"
                        onClick={() => {
                          setSelected(d);
                          setShowEditModal(true);
                          setDialogType("Edit");
                        }}
                      >
                        Edit
                      </button>
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={() => {
                          setSelected(d);
                          setShowDeleteModal(true);
                        }}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </main>
      {showEditModal ? (
        <EditDesignation
          onClose={() => {
            setShowEditModal(false);
            setSelected(null);
          }}
          prevData={selected}
          dialogType={dialogType}
        />
      ) : null}
      {showDeleteModal ? (
        <DeleteModal
          onClose={onDeleteModalClose}
          data={selected}
          type={DESIGNATIONS}
        />
      ) : null}
    </>
  );
};

export default Designations;
